import { render, staticRenderFns } from "./SGDistributedLogs.vue?vue&type=template&id=4f228d63&scoped=true"
import script from "./SGDistributedLogs.vue?vue&type=script&lang=js"
export * from "./SGDistributedLogs.vue?vue&type=script&lang=js"
import style0 from "./SGDistributedLogs.vue?vue&type=style&index=0&id=4f228d63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f228d63",
  null
  
)

export default component.exports